import { Injectable } from '@angular/core';
import { ApiHeaderGenerateConfig } from '@shared/services/api-header-generate/api-header-generate.config';
import { SessionStorageService } from '@nequi/design-system-lib/logic';
import { TrazabilityEntity } from '@private/modules/cash-out-payment/core/entities/trazability.entity';
import { getKeycloakInstance } from '@shared/utils/keycloak/app.init';

@Injectable({
  providedIn: 'root',
})
export class ApiHeaderGenerateService {

  constructor(private readonly sessionStorageService: SessionStorageService) {
  }

  public generateAuthHeaders() {

    const keycloak = getKeycloakInstance();

    const messageId = keycloak.sessionId ?? '';
    const deviceId = crypto.randomUUID();
    const cus = this.sessionStorageService.getItem(ApiHeaderGenerateConfig.trazabilityCode) as TrazabilityEntity;
    const fingerPrint = this.sessionStorageService.getItem(ApiHeaderGenerateConfig.fingerPrint) as string || '';
    const loginState = this.sessionStorageService.getItem(ApiHeaderGenerateConfig.loginState) as string || '';
    const authorization = keycloak.token ?? '';

    return {
      'x-mfp-device-id': deviceId.toString() ?? '',
      'x-region-id': ApiHeaderGenerateConfig.region.toString() ?? '',
      'x-message-id': messageId.toString() ?? '',
      'x-cus-id': cus?.trazabilityCode ?? '',
      'x-usr-session': loginState ?? '',
      fingerPrint,
      'Authorization': `Bearer ${ authorization }`
    };
  }

}
